import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from '@/App';
import '@/index.css';
import 'leaflet/dist/leaflet.css';
// removed date range picker styles

// Désinscrire tous les Service Workers existants pour désactiver complètement le PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister().then((success) => {
          if (success) {
            console.log('Service Worker désinscrit avec succès');
          }
        }).catch((error) => {
          console.log('Erreur lors de la désinscription du Service Worker:', error);
        });
      }
    });

    // Supprimer tous les caches existants
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        return Promise.all(
          cacheNames.map((cacheName) => {
            console.log('Suppression du cache:', cacheName);
            return caches.delete(cacheName);
          })
        );
      });
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
